<div>
  <h2 mat-dialog-title>Change account</h2>
  <div mat-dialog-content>
    <p>In order to proceed with this transfer please choose {{data.expectedAccount}} account in your wallet</p>
  </div>
</div>
